<template>
  <footer class="contact-footer" id="contact">
    <h2>联系我们</h2>
    <div class="contact-grid">
      <div class="contact-card">
        <div class="icon"><img src="@/assets/icons/phone-icon.svg" alt="服务热线"></div>
        <h3>服务热线</h3>
        <p>400-831-7518</p>
        <p>周一至周日 9:00-18:00</p>
      </div>

      <div class="contact-card">
        <div class="icon"><img src="@/assets/icons/email-icon.svg" alt="商务合作"></div>
        <h3>商务合作</h3>
        <p>aguang@zixiancao.com</p>
        <p>wangfengyi@zixiancao.com</p>
      </div>

      <div class="contact-card">
        <div class="icon"><img src="@/assets/icons/location-icon.svg" alt="公司地址"></div>
        <h3>公司地址</h3>
        <p>广东省深圳市龙岗区大运软件小镇</p>
      </div>

      <div class="contact-card">
        <div class="icon"><img src="@/assets/icons/wechat-icon.svg" alt="关注我们"></div>
        <h3>关注我们</h3>
        <p>微信公众号关注【滋仙草】</p>
        <p>官方抖音搜索【滋仙草旗舰店】</p>
      </div>
    </div>
    <ContactFriend placement="footer" />
    <div class="footer-bottom">
      <p><a href="/about.html">品牌故事</a> · <a href="/products.html">匠心产品</a> · <a href="/quality.html">品质信息</a> · <a href="/faq.html">常见问题</a> · <a href="/contact.html">联系我们</a></p>
      <p>© 2024 滋仙草. 版权所有</p>
      <p><a href="https://beian.miit.gov.cn" target="_blank" rel="noopener" class="icp-link">粤ICP备2024239587号</a></p>
    </div>
  </footer>
</template>

<script>
import ContactFriend from './ContactFriend.vue';

export default {
  name: 'ContactFooter',
  components: {
    ContactFriend
  }
}
</script>

<style scoped>
.contact-footer {
  background-color: #4b0082;
  color: white;
  padding: 48px 0 32px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.contact-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 18px;
}

.icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 14px;
}

.icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

h3 {
  font-size: 1.2em;
  margin: 0 0 10px;
}

p {
  margin: 6px 0;
  font-size: 0.95em;
  line-height: 1.5;
}

.footer-bottom {
  margin: 40px auto 0;
  padding: 16px 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 1200px;
  box-sizing: border-box;
}

.footer-bottom p {
  margin: 5px 0;
  font-size: 0.9em;
  opacity: 0.85;
}

.footer-bottom a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
}

.footer-bottom a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }

  .contact-card {
    max-width: 400px;
    margin: 0 auto;
  }

  h2 {
    font-size: 1.5em;
  }
}
</style>
